import classNames from 'classnames'
import { isFunction } from 'lodash'
import React from 'react'
interface CategoryTabsType {
  categories: any
  sm?: boolean
  md?: boolean
  lg?: boolean
  xl?: boolean
  fullTabs?: boolean
  activeTab?: number | string
  setActiveTab?: any
  onClick?: any
  linkTo?: any
  center?: boolean
  paddingX?: number
  tabListContainerClx?: any
  tabWrapperClx?: any
}

const CategoryTabs: React.FC<CategoryTabsType> = ({
  activeTab,
  sm,
  md,
  lg,
  xl,
  fullTabs,
  categories,
  setActiveTab,
  center,
  linkTo,
  onClick,
  paddingX,
  tabListContainerClx, //outter
  tabWrapperClx, //inner
}) => {
  const tabList = categories?.filter((listItem: any) => listItem.none != true) || []

  const tabListContainerClassName = classNames('mb-16', tabListContainerClx, { 'flex justify-center': center })
  const tabWrapperClassName = tabWrapperClx + ' flex inline-flex relative z-1'

  const tabClassName: HTMLDivElement | any = (tabItem: any) =>
    classNames(
      'flex h-[48px] cursor-pointer items-center justify-center border-b-2 text-center text-[14px]  hover:bg-gray-50 hover:text-purple-500',
      activeTab == tabItem.id ? 'border-purple-500 bg-gray-100 text-purple-500' : 'text-gray-300',
      sm && 'min-w-[85px]',
      md && 'px-[40px]',
      lg && 'min-w-[170px]',
      xl && 'px-[64px]',
      fullTabs && 'w-full'
    )

  const handleTabClick = (event: React.MouseEvent, item: any) => {
    setActiveTab(item.id)

    if (isFunction(onClick)) {
      onClick(event, item.id)
    }
  }
  return (
    <div className={tabListContainerClassName}>
      {tabList.map((tabListItem: any, i: number) => {
        return (
          <div key={i} className={tabWrapperClassName} onClick={() => linkTo && linkTo(tabListItem.href)}>
            <div
              className={tabClassName(tabListItem)}
              style={{ paddingLeft: `${paddingX}px`, paddingRight: `${paddingX}px` }}
              onClick={(event) => handleTabClick(event, tabListItem)}
              data-ref={tabListItem.dataRef && tabListItem.dataRef}
            >
              {tabListItem.title}
            </div>
          </div>
        )
      })}
      <div className="-z-1 absolute bottom-[0px] w-full border-b-2 border-gray-200"></div>
    </div>
  )
}

export default CategoryTabs

export const MobileCategoryTabs: React.FC<any> = ({
  activeTab,
  categories,
  setActiveTab,
  outsideClassName,
  innerClassName,
  tabButtonClassName,
}) => {
  return (
    <div className={classNames(outsideClassName)}>
      {categories
        ?.filter((categoriesItem: any) => categoriesItem.none != true)
        .map((categoriesItem: any, i: number) => {
          return (
            <div key={i} className={classNames(innerClassName, 'relative z-[1] flex inline-flex')}>
              <div
                onClick={() => {
                  setActiveTab(categoriesItem.id)
                }}
                className={classNames(
                  `' + flex cursor-pointer items-center justify-center text-center ${tabButtonClassName}`,
                  [
                    activeTab == categoriesItem.id && 'border-b-2 border-purple-500 text-purple-500',
                    activeTab != categoriesItem.id && 'border-b-2 text-gray-300',
                  ],
                  'cursor-pointer'
                )}
              >
                {categoriesItem.title}
              </div>
            </div>
          )
        })}
      <div className="-z-1 absolute bottom-[0px] w-full border-b-2 border-gray-200"></div>
    </div>
  )
}
